"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldText = exports.ModelMutatorText = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorText extends collection_field_1.ModelMutator {
    manual(newText) {
        if (newText == null || newText.length === 0) {
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            this.state.setFieldValue(this.field.id, newText);
        }
    }
    copy(from) {
        // Cannot use super.copy. See TODO above
        this.manual(from.value);
        return true;
    }
}
exports.ModelMutatorText = ModelMutatorText;
class CollectionModelFieldText extends collection_field_1.CollectionModelField {
    constructor() {
        super(...arguments);
        this._Mutator = new ModelMutatorText(this);
    }
    static isTextField(f) {
        return f.schema.type === CollectionModelFieldText.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorText(this);
        }
        return this._Mutator;
    }
    get value() {
        return this.stateValue || '';
    }
    get displayValue() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return '';
        }
        return stateValue || '';
    }
    hasValue() {
        const value = this.value;
        if (value == null || value === '') {
            return false;
        }
        return true;
    }
}
exports.CollectionModelFieldText = CollectionModelFieldText;
CollectionModelFieldText.TYPE = core_api_1.IkeFieldType.TEXT;
//# sourceMappingURL=text.field.js.map